var _defs, _line, _line2, _line3, _path, _polygon, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#128abc;stroke-linecap:round;stroke-linejoin:round;stroke-width:5px;}"))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 84.21,
    y1: 126.78,
    x2: 171.79,
    y2: 126.78
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 84.21,
    y1: 159.07,
    x2: 171.79,
    y2: 159.07
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 84.21,
    y1: 191.36,
    x2: 171.79,
    y2: 191.36
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M195.27,18H102L45.5,67.9V222.77A15.27,15.27,0,0,0,60.73,238H195.27a15.27,15.27,0,0,0,15.23-15.23V33.23A15.27,15.27,0,0,0,195.27,18Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "102.01 18 101.77 67.82 45.5 67.9 102.01 18"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M182.47,90.31V76.78c0-7.45-6-10.2-12.94-10.2L161.62,76l-8.54-9.39c-6.94,0-12.33,2.75-12.33,10.2V90.31Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M171.26,48.47a9.65,9.65,0,1,1-19.3,0V44.84a9.65,9.65,0,1,1,19.3,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.d0799d3d1ab2c07273e038c26f12d91f.svg";
export { ForwardRef as ReactComponent };